import { useState, useEffect } from 'react';
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_DATE_DDMMMYYYY } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _AbstractAccount, _single } from '../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { Modal } from '../../theme/Component/Modal';
import { EntityTypeConstantsEditor } from './Editor/EntityTypeConstants.editor';
import { DocTypeConstantsEditor } from './Editor/DocTypeConstants.editor';
import { SelectSiteID } from '../../admin/configuracion/SiteID/SelectSiteID';
import { BakingEntityEditor } from '../../erp/cellEditor/BankingEntity/BankingEntitySelect';
import { BankingAccountEditor } from '../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/BankingAccountSelect';
import { BasicSwitch } from '../../theme/Component/BasicSwitch';
import { FileInput } from '../../theme/Component/FileInput';
import { GenderTypeConstantsEditor } from './Editor/GenderTypeConstants.editor';
import { InputDate } from '../../theme/Input/InputDate';
import { BloodTypeConstantsEditor } from './Editor/BloodTypeConstants.editor';
import { RhTypeConstantsEditor } from './Editor/RhTypeConstants.editor';
import { MilitaryStatusConstantsEditor } from './Editor/MilitaryStatusConstants.editor';
import { CivilStatusConstantsEditor } from './Editor/CivilStatusConstants.editor';
import { RaceTypeConstantsEditor } from './Editor/RaceTypeConstants.editor';
import { HousingTypeConstantsEditor } from './Editor/HousingTypeConstants.editor';
import { StudiesTypeConstantsEditor } from './Editor/StudiesTypeConstants.editor';
import { AccountEditor } from '../../editor/AccountEditor';
import { CardTaps } from '../../theme/Component/CardTaps';
import CameraCapture from '../../theme/Component/CameraCapture';
import { ThirdBankingAccount } from '../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount';
import { PrintJson } from '../../theme/Component/PrintJson';
import usePaginator from '../../theme/Component/usePaginator';
import { _AbstractAccountbypage, _ExportAccountList, _ImpRut } from '../../../core/services/dataBean/EntityCatalogVdos';
import { SelectTHConstantsValue } from '../../bpm/config/Componentes/SelectTHConstantsValue';
import { RelationshipTypeEditor } from '../../Talentohumano/ParametrosTalentoHumano/RelationshipType/RelationshipTypeEditor';
import { PopulationTypeEditor } from '../../Talentohumano/ParametrosTalentoHumano/PopulationType/PopulationTypeEditor';
import { SexTypeEditor } from '../../Talentohumano/ParametrosTalentoHumano/SexType/SexTypeEditor';
import { EthnicGroupEditor } from '../../Talentohumano/ParametrosTalentoHumano/EthnicGroup/EthnicGroupEditor';
import { RelationshipByOwner } from './RelationshipByOwner';
import { VehicleByAccount } from '../../../core/services/dataBean/talentoHumano/cofigpresupuestoycompras/VehicleByAccount';
import { VehicleByAccountNew } from './VehicleByAccountNew';
import { Fingerprint } from './Fingerprint';
import { PersonPhoto } from './PersonPhoto';
import { CitiesEditor } from '../../Inventories-Warehouses/Product/Countries/Cities/CitiesEditor';
import { CountriesEditor } from '../../Inventories-Warehouses/Product/Countries/CountriesEditor';
import { CIUO88ACAccount } from './CIUO88ACAccount/CIUO88ACAccount';
import { HealthDisabilityAccount } from './HealthDisabilityAccount/HealthDisabilityAccount';
import { WelfareEntityEditorTable } from '../../Talentohumano/WelfareEntity/WelfareEntityEditorTable';
import { SiteTypeEditor } from '../../Inventories-Warehouses/Product/SiteType/SiteTypeEditor';
import { HandedTypeConst } from './Editor/HandedTypeConst';
import { HealthRegimenEditor } from './HealthRegimen/HealthRegimenEditor';
import useModal, { MODAL_LG, MODAL_md } from '../../theme/Component/hooks/useModal';

interface AbstractAccountModifyPermissions {
    editTabs: {
        informacionAdicional: boolean;
        foto: boolean;
        contactoYUbicacion: boolean;
        informacionBasica: boolean;
        informacionFinanciera: boolean;
        cuentasBancarias: boolean;
        datosBiologicos: boolean;
        informacionPersonalDemografica: boolean;
    };
    optiontDots: {
        nucleoFamiliar: boolean;
        fotosIdentificacion: boolean;
        editar: boolean;
        ocupaciones: boolean;
        discapacidadesFisicas: boolean;
        huellasDigitales: boolean;
        vehiculosAsociados: boolean;
    };
}

export const AbstractAccountAdminGestionBypaginator = () => {


    const absAcco = useDataBean(_AbstractAccountbypage);
    const acc = useDataBean(_AbstractAccount);
    const exp = useDataBean(_ExportAccountList);
    const imp = useDataBean(_ImpRut);
    const single = Singleton.getInstance();
    const [formato, setFormato] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [permissions, setPermissions] = useState<AbstractAccountModifyPermissions | null>(null);
    const modalViewLink = useModal('Archivo exportado', MODAL_md);
    const modalCreate = useModal('Crear tercero', MODAL_md);
    const modalOccupation = useModal('Ocupaciones', MODAL_LG);
    const modalFingerprint = useModal('Huellas Digitales', MODAL_LG);
    const modalPhoto = useModal('Editar Fotos', MODAL_LG);
    const modalVehicle = useModal('Editar Vehículos', MODAL_LG);
    const modalFamily = useModal('Editar Núcleo', MODAL_LG);
    const modalRut = useModal('Importar RUT', MODAL_md);
    const modalExport = useModal('Exportar terceros', MODAL_md);
    const modalEdit = useModal('Editar Información', MODAL_LG);
    const modalDisability = useModal('Discapacidades Físicas', MODAL_LG);
    const [surname, setsurname] = useState<any>(null)
    const [nameport, setnameport] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [Nit, setNit] = useState<any>(null)
    const paginador = usePaginator();

    useEffect(() => {
        acc.instance.getAbstractAccountModifyPermissions(_single.getAccountID()).then(
            (resp) => {
                setPermissions(resp as AbstractAccountModifyPermissions)
            }
        ).catch(err => { toast.error(err) })
    }, [])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {


        absAcco.instance.getAccountBypage(nameport, surname, regexStr, Nit, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const createAcc = () => {
        absAcco.instance.createAccount(absAcco.bean.EntityType, absAcco.bean.DocType, absAcco.bean.Nit).then(
            (resp) => {
                //console.log(resp)
                getLista()
                modalCreate.close()
            }
        ).catch(err => { toast.error(err) })
    }

    const exportAccountList = () => {
        //console.log(entailment.bean);
        exp.instance.exportAccountList(exp.bean.regexStr).then(
            (resp: any) => {
                setFormato(resp[0]);
                modalExport.close();
                modalViewLink.open();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const updateAbstracAccount = () => {
        setIndexTap(0)
        let x = absAcco.bean;
        x.IDEmployee = single.getAccountID();
        x.LastUpdate = single.getCurrenDate();
        x.State = 67;
        updateAccount(x)
    }

    const updateAccount = (bean: any) => {
        //console.log(bean)
        absAcco.instance.updateAbstractAccount(bean).then(
            (resp) => {
                getLista()
                modalEdit.close()
            }
        )
    }
    const verexp = () => {
        modalExport.open()
    }
    const verrut = () => {
        modalRut.open()
    }

    const importRUT = () => {
        //console.log(entailment.bean);
        imp.instance.importRUT(_single.getAccountID(), imp.bean.Media, imp.bean.MediaContext).then(
            (resp: any) => {
                console.log(resp)
                modalRut.close();
                toast.success(resp.Account.DataBeanProperties.EntityName);
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: "IDAccount" },
        { title: 'Cédula/Nit', property: 'Nit' },
        { title: 'Nombre', property: 'EntityName' },
        { title: 'Ciudad de Residencia', property: 'CitiesResidenceName' },
        { title: 'Nacionalidad', property: 'CountriesNationalityName' },
        { title: 'Correo', property: 'eMail' },
        { title: 'Teléfono', property: 'Tel' },
        { title: 'Tipo de Naturaleza', property: 'EntityTypeName' },
        { title: 'Modificado Por', property: 'EmployeeName', visible: false },
        { title: 'Ultima Modificacion', property: 'LastUpdate', visible: false },
    ]
    const create = () => {
        absAcco.setBean({

        });
        modalCreate.open();
    }
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => modalEdit.open() },
            { titulo: 'Núcleo Familiar', icono: 'ri-team-fill', visible: single.canEdit() && permissions?.optiontDots?.nucleoFamiliar === true, evento: () => modalFamily.open() },
            { titulo: 'Vehículos Asociados', icono: 'ri-car-line', visible: single.canEdit() && permissions?.optiontDots?.vehiculosAsociados === true, evento: () => modalVehicle.open() },
            { titulo: 'Huellas Digitales', icono: 'ri-fingerprint-line', visible: single.canEdit() && permissions?.optiontDots?.huellasDigitales === true, evento: () => modalFingerprint.open() },
            { titulo: 'Fotos de Identificación', icono: 'ri-profile-fill', visible: single.canEdit() && permissions?.optiontDots?.fotosIdentificacion === true, evento: () => modalPhoto.open() },
            { titulo: 'Ocupaciones', icono: 'ri-radio-button-line', visible: single.canEdit() && permissions?.optiontDots?.ocupaciones === true, evento: () => modalOccupation.open() },
            { titulo: 'Discapacidades Físicas', icono: 'ri-hand-heart-line', visible: single.canEdit() && permissions?.optiontDots?.discapacidadesFisicas === true, evento: () => modalDisability.open() },
            // { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            // { titulo: 'Activar cuenta', icono: 'ri-file-user-line', visible: true, evento: () => { setModal1({ ...modal1, "view": true }) } },
            // { titulo: 'Agregar empresa', icono: 'ri-file-user-line', visible: true, evento: () => { setModalEditar({ ...modalEditar, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]


    const tapsNatural = [
        { id: 0, name: 'Información Básica', visible: permissions?.editTabs?.informacionBasica },
        { id: 1, name: 'Contacto y Ubicación', visible: permissions?.editTabs?.contactoYUbicacion },
        { id: 2, name: 'Información Financiera', visible: permissions?.editTabs?.informacionFinanciera },
        { id: 3, name: 'Información Adicional', visible: permissions?.editTabs?.informacionAdicional },
        { id: 4, name: 'Cuentas Bancarias', visible: permissions?.editTabs?.cuentasBancarias },
        { id: 5, name: 'Foto', visible: permissions?.editTabs?.foto },
        { id: 6, name: 'Información Personal/Demográfica', visible: permissions?.editTabs?.informacionPersonalDemografica },
        { id: 7, name: 'Datos Biológicos', visible: permissions?.editTabs?.datosBiologicos },
    ].filter(tap => tap.visible === true)

    const tapsJuridica = [
        { id: 0, name: 'Información Basica', visible: permissions?.editTabs?.informacionBasica },
        { id: 1, name: 'Contacto y Ubicación', visible: permissions?.editTabs?.contactoYUbicacion },
        { id: 2, name: 'Información Financiera y Otros', visible: permissions?.editTabs?.informacionFinanciera },
        { id: 3, name: 'Cuentas Bancarias', visible: permissions?.editTabs?.cuentasBancarias },
        { id: 4, name: 'Información Personal/Demográfica', visible: permissions?.editTabs?.informacionPersonalDemografica },
        { id: 5, name: 'Datos Biológicos', visible: permissions?.editTabs?.datosBiologicos },
    ].filter(tap => tap.visible === true)

    const [indexTap, setIndexTap] = useState(0);

    useEffect(() => {
        setIndexTap(0)
    }, [lista])

    useEffect(() => {
        if (!modalEdit.modal.view) return;

        const allowedTabs = absAcco.bean.EntityType == 3 ? tapsJuridica : tapsNatural;
        if (!allowedTabs.some(tap => tap.id === indexTap)) {
            setIndexTap(allowedTabs[0]?.id ?? 0);
        }
    }, [modalEdit.modal.view, absAcco.bean.EntityType, permissions, indexTap])

    return (
        <>
            <BasicPage titulo="Consultar y Editar Cuenta de Tercero">
                <div className="row">
                    <div className="col-md-4">
                        <label>Nombres</label>
                        <input type="text" name="regexStr" className="form-control" value={nameport} onChange={(e) => { setnameport(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Apellidos</label>
                        <input type="text" name="regexStr" className="form-control" value={surname} onChange={(e) => { setsurname(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Identificación</label>
                        <input type="text" name="regexStr" className="form-control" value={Nit} onChange={(e) => { setNit(parseInt(e.target.value)) }} />
                    </div>
                    <div className="col-md-2 mt-4 p-2">
                        <BasicButton value="Buscar" icon="ri-search-line" eventClick={getLista} ></BasicButton>
                    </div>
                    <div className="col-md-2 mt-4 p-2">
                        <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verexp}>
                            Exportar Terceros
                        </BasicButton>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verrut}>
                            Importar RUT
                        </BasicButton>
                    </div>
                </div>
                <div className="row">
                    <BasicTable listButtons={listaBotones()} head={head} iconButtons={iconButtonsItem} body={lista} rowSet={absAcco.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15} />
                </div>
            </BasicPage>
            <Modal modal={modalCreate.modal} updateModal={modalCreate.setModal} eventModal={createAcc}>
                <div className="row">
                    <div className="col-12">
                        <EntityTypeConstantsEditor idSelector={absAcco.bean.EntityType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "EntityType": e }) }} label='Tipo de Tercero' />
                    </div>
                    <div className="col-12">
                        <DocTypeConstantsEditor idSelector={absAcco.bean.DocType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "DocType": e }) }} label='Tipo de Documento' />
                    </div>
                    <div className="col-12">
                        <label>NIT</label>
                        <input type="number" className='form-control' name='Nit' value={absAcco.bean.Nit} onChange={absAcco.handleChange} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalExport.modal} updateModal={modalExport.setModal} eventModal={exportAccountList}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Filtro por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={exp.bean.regexStr} onChange={exp.handleChange} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalOccupation.modal} updateModal={modalOccupation.setModal} >
                <div className="row">
                    <CIUO88ACAccount accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalDisability.modal} updateModal={modalDisability.setModal} >
                <div className="row">
                    <HealthDisabilityAccount accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalVehicle.modal} updateModal={modalVehicle.setModal} >
                <div className="row">
                    <VehicleByAccountNew accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalFamily.modal} updateModal={modalFamily.setModal} >
                <div className="row">
                    <RelationshipByOwner accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalFingerprint.modal} updateModal={modalFingerprint.setModal} >
                <div className="row">
                    <Fingerprint accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalPhoto.modal} updateModal={modalPhoto.setModal} >
                <div className="row">
                    <PersonPhoto accountID={absAcco.bean.IDAccount} />
                </div>
            </Modal>
            <Modal modal={modalRut.modal} updateModal={modalRut.setModal} eventModal={importRUT}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <FileInput
                                Media={imp.bean.Media}
                                MediaContext={imp.bean.MediaContext}
                                directory='Rate'
                                label='Archivo'
                                docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                            ></FileInput>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal modal={modalViewLink.modal} updateModal={modalViewLink.setModal}>
                <div className="row">
                    <div className="row">
                        {formato?.DataBeanProperties?.URLLink && (
                            // <PrintJson json={formato.DataBeanProperties.URLLink} />
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                        <strong>📄{formato.DataBeanProperties.Filename}</strong>
                                    </a>
                                </div>
                            </div>

                        )}



                    </div>
                </div>
            </Modal>
            {modalEdit.modal.view &&
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { updateAbstracAccount() }}>
                    <>
                        <div className="col-12">
                            <EntityTypeConstantsEditor idSelector={absAcco.bean.EntityType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "EntityType": e }) }} label='Tipo de Tercero' />
                        </div>
                        {/* {absAcco.bean.EntityType !== 3 || absAcco.bean.EntityType !== 4 && */}
                        {absAcco.bean.EntityType == 3 &&
                            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={tapsJuridica}>
                                {indexTap == 0 &&
                                    <>
                                        <div className="row">
                                            {/* <div className="col-6">
                                            <label>Tipo de Entidad</label>
                                            <EntityTypeConstantsEditor idSelector={absAcco.bean.EntityType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "EntityType": e }) }} label='Tipo de Tercero' />
                                        </div> */}
                                            <div className="col-6">
                                                <label>No Documento</label>
                                                <input type="number" className='form-control' value={absAcco.bean.Nit} disabled />
                                            </div>
                                            <div className="col-6">
                                                <DocTypeConstantsEditor label='Tipo Documento' idSelector={absAcco.bean.DocType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "DocType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>Digito de Verificacion</label>
                                                <input type="number" className='form-control' value={absAcco.bean.VerificationDigit} disabled />
                                            </div>
                                            <div className="col-6">
                                                <label>Razon Social</label>
                                                <input type="text" className='form-control' name='Name1' value={absAcco.bean.Name1} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <FileInput docAcept='image/tiff, image/png , image/jpeg, image/gif, image/bmp' MediaContext={'photos'} directory='photos' Media={absAcco.bean.Photo} onCreate={(e) => { absAcco.setBean({ ...absAcco.bean, "Photo": e.Media }) }} label='Foto' />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Cliente' estado={absAcco.bean.IsCustomer} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsCustomer": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Proveedor' estado={absAcco.bean.IsSupplier} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsSupplier": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Entidad Pública' estado={absAcco.bean.IsPublicEntity} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsPublicEntity": e }) }} />
                                            </div>
                                        </div>

                                    </>
                                }
                                {indexTap == 1 &&
                                    <div className="row">
                                        <div className="col-6">
                                            <CitiesEditor render={absAcco.bean.CommercialSiteIDName} idSelector={absAcco.bean.IDSite} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDSite": e.IDCities, "CommercialSiteIDName": e.Name }) }} label='Ubicación comercial/Notificaciones' returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <label>Dirección</label>
                                            <input type="text" className='form-control' name='Address' value={absAcco.bean.Address} onChange={absAcco.handleChange} />
                                        </div>
                                        <div className="col-6">
                                            <label>Telefono</label>
                                            <input type="text" className='form-control' name='Tel' value={absAcco.bean.Tel} onChange={absAcco.handleChange} />
                                        </div>
                                        <div className="col-6">
                                            <label>Correo Electrónico</label>
                                            <input type="text" className='form-control' name='eMail' value={absAcco.bean.eMail} onChange={absAcco.handleChange} />
                                        </div>
                                        <div className="col-6">
                                            <SiteTypeEditor render={absAcco.bean.ResidenceSiteTypeName} idSelector={absAcco.bean.IDResidenceSiteType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDResidenceSiteType": e.IDSiteType, "ResidenceSiteTypeName": e.Name }) }} label='Zona Territorial de Residencia' returnType="Object" />
                                        </div>
                                        <div className="col-md-6">
                                            <CitiesEditor render={absAcco.bean.CitiesResidenceName} idSelector={absAcco.bean.IDCitiesResidence} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCitiesResidence": e.IDCities, "CitiesResidenceName": e.Name }) }} label='Ciudad de Residencia' returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <CountriesEditor render={absAcco.bean.CountriesNationalityName} idSelector={absAcco.bean.IDCountriesNationality} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCountriesNationality": e.IDCountries, "CountriesNationalityName": e.Name }) }} label='Nacionalidad' returnType="Object" />
                                        </div>
                                    </div>
                                }
                                {indexTap == 2 &&
                                    <div className="row">
                                        <div className="col-6">
                                            <BakingEntityEditor label='Entidad Bancaria' idSelector={absAcco.bean.BankingID} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BankingID": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <BankingAccountEditor label='Tipo de Cuenta' idSelector={absAcco.bean.BankingAccountType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BankingAccountType": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <label>No Cuenta Bancaria</label>
                                            <input type="text" className='form-control' name='BankingAccountNumber' value={absAcco.bean.BankingAccountNumber} onChange={absAcco.handleChange} />
                                        </div>
                                        <div className="col-6">
                                            <BasicSwitch label='Responsable de Renta' estado={absAcco.bean.RentTax} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RentTax": e }) }} />
                                        </div>

                                    </div>

                                }
                                {indexTap == 3 &&
                                    <ThirdBankingAccount isModal idAccount={absAcco.bean.IDAccount} />
                                }
                                {indexTap == 4 &&
                                    <div className="row">
                                        <div className="col-md-6">
                                            <CivilStatusConstantsEditor label='Estado Civil' idSelector={absAcco.bean.IDCivilStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCivilStatus": e }) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <HealthRegimenEditor render={absAcco.bean.HealthRegimenName} idSelector={absAcco.bean.IDHealthRegimen} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthRegimen": e.IDHealthRegimen, "HealthRegimenName": e.Name }) }} returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <WelfareEntityEditorTable render={absAcco.bean.WelfareEntityName} idSelector={absAcco.bean.IDHealthWelfareEntity} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthWelfareEntity": e.IDWelfareEntity, "WelfareEntityName": e.AccountName }) }} returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <EthnicGroupEditor render={absAcco.bean.EthnicGroupName} idSelector={absAcco.bean.IDEthnicGroup} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDEthnicGroup": e.IDEthnicGroup, "EthnicGroupName": e.Name }) }} label='Grupo Étnico' returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <SexTypeEditor render={absAcco.bean.SexTypeName} idSelector={absAcco.bean.IDSexType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDSexType": e.IDSexType, "SexTypeName": e.Name }) }} returnType="Object" />
                                        </div>
                                        <div className="col-md-6">
                                            <PopulationTypeEditor render={absAcco.bean.PopulationTypeName} idSelector={absAcco.bean.IDPopulationType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDPopulationType": e.IDPopulationType, "PopulationTypeName": e.Name }) }} label='Comunidad Étnica' returnType="Object" />
                                        </div>

                                        <div className="col-6">
                                            <MilitaryStatusConstantsEditor label='Estatus Militar' idSelector={absAcco.bean.MilitaryStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "MilitaryStatus": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <HousingTypeConstantsEditor label='Tipo Vivienda' idSelector={absAcco.bean.HousingType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "HousingType": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <StudiesTypeConstantsEditor label='Nivel de Estudios' idSelector={absAcco.bean.StudiesLevel} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "StudiesLevel": e }) }} />
                                        </div>
                                    </div>
                                }
                                {indexTap == 5 &&
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Fecha en que suscribe el documento de Donación</label>
                                            <InputDate name='OrganDonorDate' value={absAcco.bean.OrganDonorDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "OrganDonorDate": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <label>Fecha de Suscripción, Modificación, sustitución o renovación de voluntad anticipada</label>
                                            <InputDate name='RefuseLifePreservingTreatmentDate' value={absAcco.bean.RefuseLifePreservingTreatmentDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "RefuseLifePreservingTreatmentDate": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <WelfareEntityEditorTable render={absAcco.bean.HealthWelfareEntityRefuseName} idSelector={absAcco.bean.IDHealthWelfareEntityRefuse} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthWelfareEntityRefuse": e.IDWelfareEntity, "HealthWelfareEntityRefuseName": e.AccountName }) }} label='Código del Prestador donde se encuentra el documento de la voluntad anticipada' returnType="Object" />
                                        </div>
                                        <div className="col-6">
                                            <BloodTypeConstantsEditor label='Tipo de Sangre' idSelector={absAcco.bean.BloodType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BloodType": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <RhTypeConstantsEditor label='Tipo de RH' idSelector={absAcco.bean.RhType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RhType": e }) }} />
                                        </div>
                                        <div className="col-6">
                                            <GenderTypeConstantsEditor label='Genero' idSelector={absAcco.bean.GenType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "GenType": e }) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <HandedTypeConst label='Lateralidad' idSelector={absAcco.bean.Laterality} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "Laterality": e }) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <BasicSwitch label='Es Donador de Organos' estado={absAcco.bean.IsOrganDonor} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsOrganDonor": e }) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <BasicSwitch label='Rechaza cualquier tratamiento de preservación de vida' estado={absAcco.bean.RefuseLifePreservingTreatment} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RefuseLifePreservingTreatment": e }) }} />
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-6">
                                        <EntityTypeConstantsEditor disabled={true} label='Estado del Registro' idSelector={absAcco.bean.State} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "State": e }) }} />
                                    </div>
                                </div>
                            </CardTaps>
                        }

                        {absAcco.bean.EntityType == 4 &&
                            <>
                                <CardTaps index={indexTap} updateIndex={setIndexTap} taps={tapsNatural}>
                                    {indexTap == 0 &&
                                        <div className="row">
                                            {/* <div className="col-6">
                                                <label>Tipo de Entidad</label>
                                                <EntityTypeConstantsEditor idSelector={absAcco.bean.EntityType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "EntityType": e }) }} label='Tipo de Tercero' />
                                            </div> */}
                                            <div className="col-6">
                                                <label>No Documento</label>
                                                <input type="number" className='form-control' value={absAcco.bean.Nit} disabled />
                                            </div>
                                            <div className="col-6">
                                                <label>Digito de Verificacion</label>
                                                <input type="number" className='form-control' value={absAcco.bean.VerificationDigit} disabled />
                                            </div>
                                            <div className="col-6">
                                                <DocTypeConstantsEditor label='Tipo Documento' idSelector={absAcco.bean.DocType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "DocType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>Fecha Expedición</label>
                                                <InputDate name='FechaExpedicion' value={absAcco.bean.IDExpeditionDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "IDExpeditionDate": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <SelectSiteID label='Lugar de Expedición' edit onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDResidenceZoneType": e.IDLn }) }} idLnSite={absAcco.bean.IDResidenceZoneType} />
                                            </div>
                                            <div className="col-6">
                                                <label>Primer Nombre</label>
                                                <input type="text" className='form-control' name='Name1' value={absAcco.bean.Name1} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Segundo Nombre</label>
                                                <input type="text" className='form-control' name='Name2' value={absAcco.bean.Name2} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Primer Apellido</label>
                                                <input type="text" className='form-control' name='Surname1' value={absAcco.bean.Surname1} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Segundo Apellido</label>
                                                <input type="text" className='form-control' name='Surname2' value={absAcco.bean.Surname2} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Titulo</label>
                                                <input type="text" className='form-control' name='CommercialName' value={absAcco.bean.CommercialName} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Fecha Nacimiento</label>
                                                <InputDate name='Fecha Nacimiento' value={absAcco.bean.BornDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "BornDate": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <FileInput docAcept='image/tiff, image/png , image/jpeg, image/gif, image/bmp' MediaContext={'photos'} directory='photos' Media={absAcco.bean.Photo} onCreate={(e) => { absAcco.setBean({ ...absAcco.bean, "Photo": e.Media }) }} label='Foto' />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Cliente' estado={absAcco.bean.IsCustomer} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsCustomer": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Proveedor' estado={absAcco.bean.IsSupplier} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsSupplier": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Entidad Pública' estado={absAcco.bean.IsPublicEntity} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsPublicEntity": e }) }} />
                                            </div>
                                        </div>
                                    }
                                    {indexTap == 1 &&
                                        <div className="row">
                                            <div className="col-md-6">
                                                <CitiesEditor render={absAcco.bean.BornSiteIDName} idSelector={absAcco.bean.IDBornSiteLn} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDBornSiteLn": e.IDCities, "BornSiteIDName": e.Name }) }} label='Lugar de Nacimiento' returnType="Object" />
                                            </div>
                                            {/* <div className="col-6">
                                                <SelectSiteID label='Lugar de Nacimiento' edit onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDBornSiteLn": e.IDLn }) }} idLnSite={absAcco.bean.IDBornSiteLn} />
                                            </div> */}
                                            {/* <div className="col-6">
                                                <SelectSiteID label='Lugar de Residencia' edit onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDResidenceSiteLn": e.IDLn }) }} idLnSite={absAcco.bean.IDResidenceSiteLn} />
                                            </div> */}
                                            <div className="col-6">
                                                <label>Dirección</label>
                                                <input type="text" className='form-control' name='Address' value={absAcco.bean.Address} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Telefono</label>
                                                <input type="text" className='form-control' name='Tel' value={absAcco.bean.Tel} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Correo Electrónico</label>
                                                <input type="text" className='form-control' name='eMail' value={absAcco.bean.eMail} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Correo Institucional</label>
                                                <input type="text" className='form-control' name='eMailCorporate' value={absAcco.bean.eMailCorporate} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <SiteTypeEditor render={absAcco.bean.ResidenceSiteTypeName} idSelector={absAcco.bean.IDResidenceSiteType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDResidenceSiteType": e.IDSiteType, "ResidenceSiteTypeName": e.Name }) }} label='Zona Territorial de Residencia' returnType="Object" />
                                            </div>
                                            <div className="col-md-6">
                                                <CitiesEditor render={absAcco.bean.CitiesResidenceName} idSelector={absAcco.bean.IDCitiesResidence} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCitiesResidence": e.IDCities, "CitiesResidenceName": e.Name }) }} label='Ciudad de Residencia' returnType="Object" />
                                            </div>
                                            <div className="col-6">
                                                <CountriesEditor render={absAcco.bean.CountriesNationalityName} idSelector={absAcco.bean.IDCountriesNationality} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCountriesNationality": e.IDCountries, "CountriesNationalityName": e.Name }) }} label='Nacionalidad' returnType="Object" />
                                            </div>
                                            {/* <div className="col-md-12">
                                                <PrintJson json={absAcco.bean}/>
                                            </div> */}
                                        </div>
                                    }
                                    {indexTap == 2 &&
                                        <div className="row">
                                            <div className="col-6">
                                                <BakingEntityEditor label='Entidad Bancaria' idSelector={absAcco.bean.BankingID} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BankingID": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <BankingAccountEditor label='Tipo de Cuenta' idSelector={absAcco.bean.BankingAccountType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BankingAccountType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>No Cuenta Bancaria</label>
                                                <input type="text" className='form-control' name='BankingAccountNumber' value={absAcco.bean.BankingAccountNumber} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BankingAccountNumber": e.target.value }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>Dependencia</label>
                                                <input type="text" className='form-control' name='Dependency' value={absAcco.bean.Dependency} onChange={absAcco.handleChange} />
                                            </div>

                                            <div className="col-6">
                                                <label>Cargo</label>
                                                <input type="text" className='form-control' name='Chargement' value={absAcco.bean.Chargement} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="col-8">
                                                        <AccountEditor idAccount={absAcco.bean.IDTaxDependentAccount} label='Dependiente para Impuestos' onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDTaxDependentAccount": e.IDAccount }) }} />
                                                    </div>
                                                    <div className="col-4 d-flex align-items-end">
                                                        <BasicButton clase='danger' icon='ri-delete-back-2-line' eventClick={() => { absAcco.setBean({ ...absAcco.bean, "IDTaxDependentAccount": -1 }) }} >Eliminar</BasicButton>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <BasicSwitch label='Responsable de Renta' estado={absAcco.bean.RentTax} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RentTax": e }) }} />
                                            </div>
                                        </div>
                                    }
                                    {indexTap == 3 &&
                                        <div className="row">
                                            <div className="col-6">
                                                <FileInput docAcept='image/tiff, image/png , image/jpeg, image/gif, image/bmp' MediaContext={'photos'} directory='photos' Media={absAcco.bean.SignImage} onCreate={(e) => { absAcco.setBean({ ...absAcco.bean, "SignImage": e.Media }) }} label='Imágen de Firma Mecánica' />
                                            </div>
                                            <div className="col-6">
                                                <FileInput docAcept='image/tiff, image/png , image/jpeg, image/gif, image/bmp' MediaContext={'photos'} directory='photos' Media={absAcco.bean.Photo} onCreate={(e) => { absAcco.setBean({ ...absAcco.bean, "Photo": e.Media }) }} label='Foto' />
                                            </div>
                                            <div className="col-6">
                                                <SelectTHConstantsValue label='Estado Civil' code={1106} idSelect="CodeID" value={absAcco.bean.IDCivilStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCivilStatus": e }) }} />
                                                {/* <CivilStatusConstantsEditor label='Estado Civil' idSelector={absAcco.bean.CivilStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "CivilStatus": e }) }} /> */}
                                            </div>
                                            <div className="col-6">
                                                <RaceTypeConstantsEditor label='Grupo Étnico' idSelector={absAcco.bean.IDEthnicGroup} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDEthnicGroup": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <BasicSwitch label='Tiene Pasaporte' estado={absAcco.bean.Passport} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "Passport": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>No Pasaporte</label>
                                                <input type="text" className='form-control' name='PassportNumber' value={absAcco.bean.PassportNumber} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Altura (CM)</label>
                                                <input type="text" className='form-control' name='Height' value={absAcco.bean.Height} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Peso (KG)</label>
                                                <input type="text" className='form-control' name='Weight' value={absAcco.bean.Weight} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Talla Pantalon</label>
                                                <input type="text" className='form-control' name='CapSize' value={absAcco.bean.CapSize} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Talla Zapatos</label>
                                                <input type="text" className='form-control' name='ShoesSize' value={absAcco.bean.ShoesSize} onChange={absAcco.handleChange} />
                                            </div>
                                            <div className="col-6">
                                                <label>Talla Camisa</label>
                                                <input type="text" className='form-control' name='DressSize' value={absAcco.bean.DressSize} onChange={absAcco.handleChange} />
                                            </div>
                                        </div>
                                    }
                                    {indexTap == 4 &&
                                        <ThirdBankingAccount isModal idAccount={absAcco.bean.IDAccount} />
                                    }
                                    {indexTap == 5 &&
                                        <CameraCapture directory='photos' uploadFile={(e) => {

                                            absAcco.setBean({ ...absAcco.bean, "Photo": e.Media })
                                        }} />
                                    }
                                    {indexTap == 6 &&
                                        <div className="row">
                                            <div className="col-md-6">
                                                <CivilStatusConstantsEditor label='Estado Civil' idSelector={absAcco.bean.IDCivilStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDCivilStatus": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <HealthRegimenEditor render={absAcco.bean.HealthRegimenName} idSelector={absAcco.bean.IDHealthRegimen} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthRegimen": e.IDHealthRegimen, "HealthRegimenName": e.Name }) }} returnType="Object" />
                                            </div>
                                            <div className="col-6">
                                                <WelfareEntityEditorTable render={absAcco.bean.WelfareEntityName} idSelector={absAcco.bean.IDHealthWelfareEntity} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthWelfareEntity": e.IDWelfareEntity, "WelfareEntityName": e.AccountName }) }} returnType="Object" />
                                            </div>
                                            <div className="col-6">
                                                <EthnicGroupEditor render={absAcco.bean.EthnicGroupName} idSelector={absAcco.bean.IDEthnicGroup} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDEthnicGroup": e.IDEthnicGroup, "EthnicGroupName": e.Name }) }} returnType="Object" />
                                            </div>
                                            <div className="col-6">
                                                <SexTypeEditor render={absAcco.bean.SexTypeName} idSelector={absAcco.bean.IDSexType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDSexType": e.IDSexType, "SexTypeName": e.Name }) }} returnType="Object" />
                                            </div>
                                            <div className="col-md-6">
                                                <PopulationTypeEditor render={absAcco.bean.PopulationTypeName} idSelector={absAcco.bean.IDPopulationType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDPopulationType": e.IDPopulationType, "PopulationTypeName": e.Name }) }} returnType="Object" />
                                            </div>

                                            <div className="col-6">
                                                <MilitaryStatusConstantsEditor label='Estatus Militar' idSelector={absAcco.bean.MilitaryStatus} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "MilitaryStatus": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <HousingTypeConstantsEditor label='Tipo Vivienda' idSelector={absAcco.bean.HousingType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "HousingType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <StudiesTypeConstantsEditor label='Nivel de Estudios' idSelector={absAcco.bean.StudiesLevel} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "StudiesLevel": e }) }} />
                                            </div>
                                        </div>
                                    }
                                    {indexTap == 7 &&

                                        <div className="row">
                                            <div className="col-6">
                                                <label>Fecha en que suscribe el documento de Donación</label>
                                                <InputDate name='OrganDonorDate' value={absAcco.bean.OrganDonorDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "OrganDonorDate": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <label>Fecha de Suscripción, Modificación, sustitución o renovación de voluntad anticipada</label>
                                                <InputDate name='RefuseLifePreservingTreatmentDate' value={absAcco.bean.RefuseLifePreservingTreatmentDate} setDate={(e) => { absAcco.setBean({ ...absAcco.bean, "RefuseLifePreservingTreatmentDate": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <WelfareEntityEditorTable render={absAcco.bean.HealthWelfareEntityRefuseName} idSelector={absAcco.bean.IDHealthWelfareEntityRefuse} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IDHealthWelfareEntityRefuse": e.IDWelfareEntity, "HealthWelfareEntityRefuseName": e.AccountName }) }} label='Código del Prestador donde se encuentra el documento de la voluntad anticipada' returnType="Object" />
                                            </div>
                                            <div className="col-6">
                                                <BloodTypeConstantsEditor label='Tipo de Sangre' idSelector={absAcco.bean.BloodType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "BloodType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <RhTypeConstantsEditor label='Tipo de RH' idSelector={absAcco.bean.RhType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RhType": e }) }} />
                                            </div>
                                            <div className="col-6">
                                                <GenderTypeConstantsEditor label='Genero' idSelector={absAcco.bean.GenType} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "GenType": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <HandedTypeConst label='Lateralidad' idSelector={absAcco.bean.Laterality} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "Laterality": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Es Donador de Organos' estado={absAcco.bean.IsOrganDonor} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "IsOrganDonor": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <BasicSwitch label='Rechaza cualquier tratamiento de preservación de vida' estado={absAcco.bean.RefuseLifePreservingTreatment} eventChange={(e) => { absAcco.setBean({ ...absAcco.bean, "RefuseLifePreservingTreatment": e }) }} />
                                            </div>
                                        </div>
                                    }
                                    {/* <div className="col-6">
                                        <EntityTypeConstantsEditor disabled={true} label='Estado del Registro' idSelector={absAcco.bean.State} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "State": e }) }} />
                                    </div> */}
                                    <div className="row">
                                        <div className="col-6">
                                            <EntityTypeConstantsEditor disabled={true} label='Estado del Registro' idSelector={absAcco.bean.State} onChange={(e) => { absAcco.setBean({ ...absAcco.bean, "State": e }) }} />
                                        </div>
                                    </div>
                                </CardTaps>
                            </>
                        }
                    </>
                </Modal>
            }

        </>
    )
}
